import { GET_LINKED_ACCOUNTS_BY_ACCOUNTID, GET_LINKED_ACCOUNTS_BY_USERID, LINK_ACCOUNT, UNLINK_ACCOUNT } from '../actions/linkedAccounts.actions';

const initialState = {
  linkedAccounts: [],
  linkedUsers: [],
  isLoading: false,
  error: null
};

const linkedAccountsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LINKED_ACCOUNTS_BY_ACCOUNTID.REQUEST:
    case GET_LINKED_ACCOUNTS_BY_USERID.REQUEST:
    case LINK_ACCOUNT.REQUEST:
    case UNLINK_ACCOUNT.REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case GET_LINKED_ACCOUNTS_BY_ACCOUNTID.SUCCESS:
    case LINK_ACCOUNT.SUCCESS:
    case UNLINK_ACCOUNT.SUCCESS:
      return {
        ...state,
        isLoading: false,
        linkedAccounts: action.payload
      };
    case GET_LINKED_ACCOUNTS_BY_USERID.SUCCESS:
      return {
        ...state,
        isLoading: false,
        linkedUsers: action.payload
      };
    case GET_LINKED_ACCOUNTS_BY_ACCOUNTID.FAILURE:
    case GET_LINKED_ACCOUNTS_BY_USERID.FAILURE:
    case LINK_ACCOUNT.FAILURE:
    case UNLINK_ACCOUNT.FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.error
      };
    default:
      return state;
  }
};

export default linkedAccountsReducer;